import { render, staticRenderFns } from "./zAutocomplete.vue?vue&type=template&id=f1984d04&scoped=true&"
import script from "./zAutocomplete.vue?vue&type=script&lang=js&"
export * from "./zAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1984d04",
  null
  
)

export default component.exports